import NumberField from "@p-ban/common/src/components/form/NumberField/NumberField"
import useDebounce from "@p-ban/common/src/hooks/useDebounce"

import FIELD_NAMES from "../../../../constant/fieldNames"
import getDisplayCondition from "../../../../service/getDisplayCondition"
import type { OneClickFieldProps } from "../../../../types"
import OneClickField from "../../../components/1Click/form/OneClickField"
import OneClickFieldMessages from "../../../components/1Click/form/OneClickFieldMessages"
import HELP_LINKS from "../../../constant/helpLinks"

const ピン数 = ({ values, handlers, errors }: OneClickFieldProps) => {
  const { pinCnt: shouldShow } = getDisplayCondition(values)
  const onUpdateValue = useDebounce(handlers.number)
  const legend = "ピン数"

  return (
    <OneClickField isShow={shouldShow} legend={legend} helpURL={HELP_LINKS.ピン数}>
      <NumberField
        name={FIELD_NAMES.ピン数}
        value={values.pinCnt}
        onUpdateValue={onUpdateValue}
        min={1}
        max={99999}
        maxDecimalDigits={0}
        step={1}
        suffix="ピン"
        error={!!errors?.pinCnt}
        aria-label={legend}
      />
      <OneClickFieldMessages error={errors?.pinCnt} />
    </OneClickField>
  )
}

export default ピン数
